// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"cdb36ab4","353":"66872e36"}[chunkId] + ".js";
};